import {observer} from 'mobx-react';
import React from 'react';
import s from '../../../s';

interface RecycleIconProps {
    width: number;
    top: string;
    left: string;
}

@observer
export default class RecycledIcon extends React.Component<RecycleIconProps> {
    constructor(props: RecycleIconProps) {
        super(props);
    }

    render() {
        return (
            <img
                loading="lazy"
                src={`https://${s.Portal.CDNDomain}/images/cached/general/recycled-logo1.png`}
                alt="Recycled"
                width={this.props.width}
                style={{position: 'absolute', top: this.props.top, left: this.props.left}}
            />
        );
    }
}
